import { useEffect, useMemo, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import moment from "moment";
import { getClientes } from "../helpers/rutaClientes";
import { getSaldoCliente } from "../helpers/rutaReportes";
import { generarPDFSaldoCliente } from "../helpers/pdfSaldoCliente";

export default function ModalSaldoCliente({ show, onHide, clientePreseleccionado = null }) {
  const [loading, setLoading] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [clienteId, setClienteId] = useState(
    clientePreseleccionado?._id ? String(clientePreseleccionado._id) : ""
  );
  const [fechaCorte, setFechaCorte] = useState(() => moment().format("YYYY-MM-DD"));

  useEffect(() => {
    if (!show) return;
    (async () => {
      setLoading(true);
      try {
        const resp = await getClientes();

        // 1) Tomar array de clientes sin importar la forma del response
        const raw = Array.isArray(resp?.clientes) ? resp.clientes
                 : Array.isArray(resp) ? resp
                 : [];

        // 2) Función para elegir el mejor nombre visible
        const pickNombre = (c) =>
          c.razonsocial || c.razonSocial || c.razon ||
          c.nombre || c.nombres || c.apellidoNombre ||
          c.nombreFantasia || c.fantasia ||
          c.cliente || c.empresa || c.denominacion ||
          c.razonComercial || c.alias || "";

        // 3) Normalizar id (string) + label
        const lista = raw
          .map((c) => {
            const id =
              c?._id?.toString?.() ??
              c?.id?.toString?.() ??
              String(c?._id || c?.id || "");
            const label = String(pickNombre(c) || "").trim();
            return { _id: id, label: label || `SIN NOMBRE (${id.slice(-6)})`, original: c };
          })
          .filter((c) => c._id) // válidos
          .sort((a, b) => a.label.localeCompare(b.label, "es", { sensitivity: "base" }));

        setClientes(lista);

        // 4) Autoselección si no hay uno elegido aún
        if (!clienteId && lista.length) setClienteId(lista[0]._id);
      } catch (e) {
        console.error(e);
        setClientes([]);
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  // Nombre mostrado (usa el label ya normalizado)
  const clienteNombre = useMemo(() => {
    const c = clientes.find((x) => x._id === clienteId);
    return c ? c.label : "";
  }, [clientes, clienteId]);

 const generar = async () => {
  if (!clienteId) return;
  setLoading(true);
  try {
    const resp = await getSaldoCliente(clienteId, fechaCorte);
    if (!resp?.ok) {
      console.error("getSaldoCliente:", resp);
      alert(resp?.error || "No se pudo obtener datos de saldo.");
      return;
    }
    generarPDFSaldoCliente({
      clienteNombre,
      fechaCorte: fechaCorte ? new Date(fechaCorte) : new Date(),
      data: resp,
    });
  } catch (e) {
    console.error(e);
    alert("No se pudo generar el PDF.");
  } finally {
    setLoading(false);
  }
};


  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Saldo por Cliente</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="gy-2">
          <Col md={8}>
            <Form.Group>
              <Form.Label>Cliente</Form.Label>
              <Form.Select
                value={clienteId}
                disabled={loading}
                onChange={(e) => setClienteId(e.target.value)}
              >
                {!clienteId && <option value="">Seleccione un cliente...</option>}
                {clientes.map((c) => (
                  <option key={c._id} value={c._id}>
                    {c.label.toUpperCase()}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Fecha de corte</Form.Label>
              <Form.Control
                type="date"
                value={fechaCorte}
                disabled={loading}
                onChange={(e) => setFechaCorte(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Cerrar
        </Button>
        <Button variant="primary" onClick={generar} disabled={loading || !clienteId}>
          {loading ? "Generando..." : "Generar PDF"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
